import React, { useState, useEffect } from "react";

import HorizontalListItem from "../components/HorizontalListItem";
import VerticalListItem from "../components/VerticalListItem";
import PageHeader from "../components/PageHeader";
import OfferBottomSheet, { OfferCard } from "../components/OfferBottomSheet";
import DownloadToast from "../components/DownloadToast";

const GamesPage = ({
  handleItemClick,
  handleSearchEvent,
  showOverlayHeader,
  numbers,
  homeOffers = [],
}) => {
  const [filteredGames, setFilteredGames] = useState([]);
  const [selectedOffer, setSelectedOffer] = useState(null);

  useEffect(() => {
    setFilteredGames(numbers);
  }, [numbers]);

  return (
    <div className="flex flex-col relative w-full bg-gradient-to-r from-semi-blue to-light-blue">
      <PageHeader onSearchClick={() => handleSearchEvent("Search")} />

      {showOverlayHeader && (
        <div className="fixed top-0 left-1/2 -translate-x-1/2 w-full max-w-md md:max-w-lg z-40 backdrop-blur-2xl animate-appear rounded-b-xl shadow-md bg-light-blue/60 lg:hidden">
          <PageHeader onSearchClick={() => handleSearchEvent("Search")} />
        </div>
      )}

      {homeOffers.length > 0 && (
        <>
          <div className="flex items-center gap-2 mx-4 mt-5 mb-2">
            <div
              className="w-1 h-5 rounded-full"
              style={{ background: "linear-gradient(180deg, #f59e0b, #dc2626)" }}
            />
            <h2 className="text-white semiBold text-lg tracking-wide">You May Like</h2>
          </div>
          <div className="flex overflow-x-scroll pb-4 hide-scroll-bar mt-1 mx-3">
            <div className="grid grid-flow-col grid-rows-2 gap-3">
              {homeOffers.map((offer, index) => (
                <OfferCard key={index} offer={offer} onPress={setSelectedOffer} />
              ))}
            </div>
          </div>
        </>
      )}

      <div
        className="mx-4 my-4"
        style={{ height: "1px", background: "linear-gradient(90deg, transparent, rgba(70,143,175,0.3), transparent)" }}
      />

      <div className="flex flex-row justify-between items-center mx-4 mb-2">
        <div className="flex items-center gap-2">
          <div
            className="w-1 h-5 rounded-full"
            style={{ background: "linear-gradient(180deg, #468faf, #01497c)" }}
          />
          <h2 className="text-white semiBold text-lg">All Games</h2>
        </div>
        {filteredGames.length > 0 && (
          <span
            className="medium text-xs px-2.5 py-1 rounded-full"
            style={{
              background: "rgba(70,143,175,0.15)",
              color: "#89d4f5",
              border: "1px solid rgba(70,143,175,0.2)",
            }}
          >
            {filteredGames.length}
          </span>
        )}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-2.5 px-3">
        {filteredGames.map((item) => (
          <VerticalListItem
            key={item.id}
            game={item}
            handleItemClick={handleItemClick}
          />
        ))}
      </div>

      <div className="h-20"></div>

      <OfferBottomSheet
        offer={selectedOffer}
        onClose={() => setSelectedOffer(null)}
      />

      <DownloadToast games={filteredGames} />
    </div>
  );
};

export default GamesPage;
